export enum GTM_EVENT_SECTION {
  DONA_CTA_HEADER = 'DonaCTAHeader',
  DONA_CTA_STICKY = 'DonaCTASticky',
}
